import React from 'react';
import { xs_isMobile } from '../../..';
import { getEnv } from '../../env';
import { isLoadedInIframe } from '../../utils/isLoadedInIframe';

export default function SocialButtons(props) {
    const text = `${props.message} ${window.encodeURIComponent(props.ticketUrl)}`.replace(/ /g, '%20');
    const whatsappUrl = xs_isMobile ? `whatsapp://send?text=${text}` : `https://web.whatsapp.com/send?text=${text}`;
    const telegramUrl = `https://t.me/share/url?url=${props.ticketUrl}&text=${props.message}`;

    return (
        <>
            <div id="whatsapp" className="mb_7_1_2_1">
                <a href={whatsappUrl} target={`${isLoadedInIframe() ? '_system' : '_self'}`} className="mb_7_1_2_1_1">
                    <img src={`${getEnv('PUBLIC_URL')}/assets/images/whatsapp.svg`} height="32px" width="32px" alt="WhatsApp share button" className="mb_7_1_2_1_1_1" />
                </a>
            </div>
            <div id="telegram" className="mb_7_1_2_1">
                <a href={telegramUrl} target={`${isLoadedInIframe() ? '_system' : '_self'}`} className="mb_7_1_2_1_1">
                    <img src={`${getEnv('PUBLIC_URL')}/assets/images/telegram.svg`} height="32px" width="32px" alt="Telegram share button" className="mb_7_1_2_1_1_1" />
                </a>
            </div>
        </>
    );
}
